export default "__VITE_PUBLIC_ASSET__9915b677__"